import Svg, { ClipPath, Defs, G, Path, Rect, Text, TSpan } from 'react-native-svg'
import { isMobile } from '../../../util/util'

export const JioPayOnLightBackground = () => {
  const viewBox = isMobile(true) ? '0 0 144 32' : '0 0 180 32'
  return (
    <Svg id="Logo-on-light" width="144" height="32" viewBox={viewBox}>
      <Defs>
        <ClipPath id="clip-path">
          <Rect
            id="Rectangle_1971"
            data-name="Rectangle 1971"
            width="32"
            height="32"
            transform="translate(0 0)"
            fill="none"
          />
        </ClipPath>
      </Defs>
      <Text
        id="JioPay_Business"
        data-name="JioPay Business"
        transform="translate(40 21)"
        fontize="14"
        fill="#000000"
        fontFamily="JioType-Bold, JioType"
        fontWeight="700">
        <TSpan x="0" y="0">
          Jio
        </TSpan>
        <TSpan y="0" letter-spacing="-0.03em">
          P
        </TSpan>
        <TSpan y="0">ay </TSpan>
        <TSpan y="0" fontFamily="JioType-Light, JioType" fontWeight="300">
          Business
        </TSpan>
      </Text>
      <G id="Group_5308" data-name="Group 5308" transform="translate(-40 -20)">
        <G id="Group_5307" data-name="Group 5307" transform="translate(40 20)" clip-path="url(#clip-path)">
          <Path
            id="Path_1948"
            data-name="Path 1948"
            d="M72,36A16,16,0,1,1,56,20,16,16,0,0,1,72,36"
            transform="translate(-40 -20.001)"
            fill="#0070b6"
          />
          <Path
            id="Subtraction_6"
            data-name="Subtraction 6"
            d="M8.468,20.645h0a3.057,3.057,0,0,1-.762-.3L6.334,19.55V16A1.067,1.067,0,1,0,4.2,16v2.322L1.83,16.949A4.049,4.049,0,0,1,0,13.781V7A4.05,4.05,0,0,1,1.83,3.827L7.705.436A3.716,3.716,0,0,1,9.534,0a3.718,3.718,0,0,1,1.829.436l5.875,3.392A4.049,4.049,0,0,1,19.069,7v6.785a4.049,4.049,0,0,1-1.829,3.168l-2.371,1.369V8.4a1.067,1.067,0,1,0-2.134,0V19.55l-1.37.791a3.065,3.065,0,0,1-.762.3V12.213a1.067,1.067,0,0,0-2.134,0v8.432Z"
            transform="translate(6.466 5.612)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            stroke-miterlimit="10"
            strokeWidth="1"
          />
          <Path
            id="Path_1950"
            data-name="Path 1950"
            d="M78.911,58.9a.825.825,0,1,1-.784.82.774.774,0,0,1,.784-.82M74.669,57.46c0-.45-.218-.675-.631-.675h-.21c-.4,0-.617.225-.617.675v2.17c0,.558-.189.755-.632.755a1.069,1.069,0,0,1-.856-.428.724.724,0,0,0-.479.726c0,.581.545.936,1.554.936,1.226,0,1.873-.617,1.873-1.967Zm1.893,1.1c0-.522-.246-.675-.625-.675h-.145c-.356,0-.624.167-.624.675v2.323c0,.515.261.675.639.675h.145c.356,0,.61-.174.61-.675Zm-.682-1.045a.651.651,0,0,0,.733-.661c0-.406-.29-.653-.755-.653a.649.649,0,0,0-.733.653c0,.406.29.661.755.661M78.9,61.619a1.889,1.889,0,1,0-1.96-1.895,1.815,1.815,0,0,0,1.96,1.895"
            transform="translate(-62.912 -46.544)"
            fill="#0070b6"
          />
        </G>
      </G>
    </Svg>
  )
}
